module.exports = __webpack_public_path__ + "static/img/02038B_3_C_20210320_LC.51022c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02038B_3_C_20210320_LC.png
// module id = g68X
// module chunks = 0